import * as fromDatatype from "../datatype-library/index";
import { MultiMemberPointsJson } from "../datatype-library/postgresql/json-datatype.model";

export interface bl_fi_generic_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  foreign_ccy: boolean;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_line_ccy: fromDatatype.CurrencyCodeDataFieldClass;
  base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  amount_cogs: fromDatatype.MoneyDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  item_desc: fromDatatype.TextDatatypeInterface;
  item_remarks: fromDatatype.TextDatatypeInterface;
  item_reference_no: fromDatatype.TextDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  item_child_json: fromDatatype.JsonDatatypeInterface;
  item_to_item_link_json: fromDatatype.JsonDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  line_option_json: fromDatatype.JsonDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  reference_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  qty_open: fromDatatype.NumericDatatypeInterface;
  point_type: fromDatatype.VarcharDatatypeInterface;
  point_amount: fromDatatype.NumericDatatypeInterface;
  point_currency: fromDatatype.CurrencyCodeDataFieldInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_hashed_value: fromDatatype.VarcharDatatypeInterface;
  serial_no: fromDatatype.VarcharDatatypeInterface;
  batch_no: fromDatatype.VarcharDatatypeInterface;
  t2t_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  t2t_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  client_data_source: fromDatatype.VarcharDatatypeInterface;
  client_item_guid: fromDatatype.GuidDataFieldInterface;
  client_item_code: fromDatatype.VarcharDatatypeInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_fi_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
  t2t_tenant_guid: fromDatatype.GuidDataFieldInterface;
  coupon_hdr_guid: fromDatatype.GuidDataFieldInterface;
  coupon_line_guid: fromDatatype.GuidDataFieldInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
  qty_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  arap_pns_amount: fromDatatype.NumericDatatypeInterface;
  arap_stlm_amount: fromDatatype.NumericDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  uom: fromDatatype.NumericDatatypeInterface;
  unit_price_std: fromDatatype.NumericDatatypeInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_txn_by_uom: fromDatatype.NumericDatatypeInterface;
  uom_to_base_ratio: fromDatatype.NumericDatatypeInterface;
  bin_no: fromDatatype.JsonDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_json: fromDatatype.JsonDatatypeInterface;
  payment_channel_name: fromDatatype.VarcharDatatypeInterface;
  parent_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  pickup_branch_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_reg_code: fromDatatype.VarcharDatatypeInterface;
  del_region_hdr_state: fromDatatype.VarcharDatatypeInterface;
  track_production_logic: fromDatatype.VarcharDatatypeInterface;
  track_production_table: fromDatatype.VarcharDatatypeInterface;
  track_production_guid: fromDatatype.GuidDataFieldInterface;
  track_production_id: fromDatatype.VarcharDatatypeInterface;
  track_production_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_production_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_production_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_production_remarks: fromDatatype.VarcharDatatypeInterface;
  track_production_status: fromDatatype.VarcharDatatypeInterface;
  track_delivery_logic: fromDatatype.VarcharDatatypeInterface;
  track_delivery_table: fromDatatype.VarcharDatatypeInterface;
  track_delivery_guid: fromDatatype.GuidDataFieldInterface;
  track_delivery_id: fromDatatype.VarcharDatatypeInterface;
  track_delivery_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_delivery_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_delivery_remarks: fromDatatype.VarcharDatatypeInterface;
  track_delivery_status: fromDatatype.VarcharDatatypeInterface;
  unit_price_net: fromDatatype.NumericDatatypeInterface;
  point_start_date: fromDatatype.TimestampTzDatatypeInterface;
  point_end_date: fromDatatype.TimestampTzDatatypeInterface;
  multi_level_disc_json: fromDatatype.JsonDatatypeInterface;
  membership_ext_start_date: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_date_requested: fromDatatype.TimestampTzDatatypeInterface;
  delivery_required: fromDatatype.VarcharDatatypeInterface;
  finance_charge_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_price: fromDatatype.NumericDatatypeInterface;
  cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  cost_wa_price: fromDatatype.NumericDatatypeInterface;
  cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_lifo_price: fromDatatype.NumericDatatypeInterface;
  cost_manual_amount: fromDatatype.NumericDatatypeInterface;
  cost_manual_price: fromDatatype.NumericDatatypeInterface;
  cost_replacement_amount: fromDatatype.NumericDatatypeInterface;
  cost_replacement_price: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_location: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_company: fromDatatype.NumericDatatypeInterface;
  posting_mto: fromDatatype.NumericDatatypeInterface;
  landed_txn_amount: fromDatatype.NumericDatatypeInterface;
  landed_txn_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_price: fromDatatype.NumericDatatypeInterface;
  delivery_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delivery_process_status_guid: fromDatatype.GuidDataFieldInterface;
  delivery_process_status_name: fromDatatype.VarcharDatatypeInterface;
  delivery_process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  delivery_process_resolution_code: fromDatatype.VarcharDatatypeInterface;
  delivery_branch_guid: fromDatatype.GuidDataFieldInterface;
  delivery_branch_code: fromDatatype.VarcharDatatypeInterface;
  delivery_location_guid: fromDatatype.GuidDataFieldInterface;
  delivery_location_code: fromDatatype.VarcharDatatypeInterface;
  tax_tariff_code: fromDatatype.GuidDataFieldInterface;
  tax_industry_code: fromDatatype.GuidDataFieldInterface;
  line_bundle_guid: fromDatatype.GuidDataFieldInterface;
  apt_weight_disc: fromDatatype.NumericDatatypeInterface;
  apt_amt_discount: fromDatatype.NumericDatatypeInterface;
  apt_amount_txn: fromDatatype.NumericDatatypeInterface;
  entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  intercompany_hdr_guid: fromDatatype.GuidDataFieldInterface;
  intercompany_line_guid: fromDatatype.GuidDataFieldInterface;
  unit_price_std_with_tax: fromDatatype.NumericDatatypeInterface;
  unit_discount: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom_with_tax: fromDatatype.NumericDatatypeInterface;
  replacement_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  pricing_scheme_link_guid: fromDatatype.GuidDataFieldInterface;
  purchase_selling_list_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  coupon_line_guid_json: fromDatatype.JsonDatatypeInterface;
  display_option: fromDatatype.VarcharDatatypeInterface;
  nsti_stock_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_01: fromDatatype.GuidDataFieldInterface;
  pic_entity_01_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02: fromDatatype.GuidDataFieldInterface;
  pic_entity_02_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03: fromDatatype.GuidDataFieldInterface;
  pic_entity_03_name: fromDatatype.VarcharDatatypeInterface;
  svc_issue_hdr_guid: fromDatatype.GuidDataFieldInterface;
  settlement_type: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
  session_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  discount_description: fromDatatype.VarcharDatatypeInterface;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  posting_budget: fromDatatype.VarcharDatatypeInterface;
  memberpoint_addon_json : MultiMemberPointsJson;
  packing_status: fromDatatype.VarcharDatatypeInterface;
  einvoice_uom: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_desc: fromDatatype.TextDatatypeInterface;
  einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_uom_desc: fromDatatype.TextDatatypeInterface;
  forex_source_hdr_guid: fromDatatype.GuidDataFieldInterface;
  forex_source_history_guid: fromDatatype.GuidDataFieldInterface;
  segment_code: fromDatatype.VarcharDatatypeInterface;
  project_code: fromDatatype.VarcharDatatypeInterface;
  profit_center_code: fromDatatype.VarcharDatatypeInterface;
  gl_dimension_code: fromDatatype.VarcharDatatypeInterface;
  mrp_request_status_production : fromDatatype.VarcharDatatypeInterface;
  mrp_request_status_schedule  : fromDatatype.VarcharDatatypeInterface;
  mrp_request_status_exists  : fromDatatype.VarcharDatatypeInterface;
  mrp_request_remarks  : fromDatatype.VarcharDatatypeInterface;
  einvoice_item_classification_code : fromDatatype.VarcharDatatypeInterface;
  einvoice_item_classification_desc : fromDatatype.VarcharDatatypeInterface;
  container_inv_item_guid: fromDatatype.GuidDataFieldInterface;
  revision_history_json: fromDatatype.JsonDatatypeInterface;
  posting_bundle : fromDatatype.VarcharDatatypeInterface;
  trade_tariff_code: fromDatatype.VarcharDatatypeInterface;
  trade_country_of_origin: fromDatatype.VarcharDatatypeInterface;
  parent_fi_item_code: fromDatatype.VarcharDatatypeInterface;
  parent_fi_item_name: fromDatatype.VarcharDatatypeInterface;
  sales_entity_hdr_code: fromDatatype.VarcharDatatypeInterface;
  cost_replacement_price_company: fromDatatype.NumericDatatypeInterface;
  cost_replacement_amount_company: fromDatatype.NumericDatatypeInterface;
  tax_exemption_details: fromDatatype.VarcharDatatypeInterface;
  tax_exemption_amount: fromDatatype.NumericDatatypeInterface;
  job_order_qty: fromDatatype.NumericDatatypeInterface;
  mrp_produced_qty: fromDatatype.NumericDatatypeInterface;
  packing_order_qty: fromDatatype.NumericDatatypeInterface;
}

export class bl_fi_generic_doc_line_RowClass
  implements bl_fi_generic_doc_line_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  foreign_ccy: boolean;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  base_doc_line_ccy: fromDatatype.CurrencyCodeDataFieldClass;
  base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  amount_cogs: fromDatatype.MoneyDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  item_desc: fromDatatype.TextDatatypeInterface;
  item_remarks: fromDatatype.TextDatatypeInterface;
  item_reference_no: fromDatatype.TextDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  item_child_json: fromDatatype.JsonDatatypeInterface;
  item_to_item_link_json: fromDatatype.JsonDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  line_option_json: fromDatatype.JsonDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  reference_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  qty_open: fromDatatype.NumericDatatypeInterface;
  point_type: fromDatatype.VarcharDatatypeInterface;
  point_amount: fromDatatype.NumericDatatypeInterface;
  point_currency: fromDatatype.CurrencyCodeDataFieldInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_key: fromDatatype.VarcharDatatypeInterface;
  client_source: fromDatatype.VarcharDatatypeInterface;
  client_hashed_value: fromDatatype.VarcharDatatypeInterface;
  serial_no: fromDatatype.VarcharDatatypeInterface;
  batch_no: fromDatatype.VarcharDatatypeInterface;
  t2t_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  t2t_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  client_data_source: fromDatatype.VarcharDatatypeInterface;
  client_item_guid: fromDatatype.GuidDataFieldInterface;
  client_item_code: fromDatatype.VarcharDatatypeInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_fi_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
  t2t_tenant_guid: fromDatatype.GuidDataFieldInterface;
  coupon_hdr_guid: fromDatatype.GuidDataFieldInterface;
  coupon_line_guid: fromDatatype.GuidDataFieldInterface;
  client_value: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
  client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
  unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
  qty_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  arap_pns_amount: fromDatatype.NumericDatatypeInterface;
  arap_stlm_amount: fromDatatype.NumericDatatypeInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  uom: fromDatatype.NumericDatatypeInterface;
  unit_price_std: fromDatatype.NumericDatatypeInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_txn_by_uom: fromDatatype.NumericDatatypeInterface;
  uom_to_base_ratio: fromDatatype.NumericDatatypeInterface;
  bin_no: fromDatatype.JsonDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_json: fromDatatype.JsonDatatypeInterface;
  payment_channel_name: fromDatatype.VarcharDatatypeInterface;
  parent_fi_item_guid: fromDatatype.GuidDataFieldInterface;
  cfg_production: fromDatatype.VarcharDatatypeInterface;
  cfg_delivery: fromDatatype.VarcharDatatypeInterface;
  pickup_branch_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_reg_code: fromDatatype.VarcharDatatypeInterface;
  del_region_hdr_state: fromDatatype.VarcharDatatypeInterface;
  track_production_logic: fromDatatype.VarcharDatatypeInterface;
  track_production_table: fromDatatype.VarcharDatatypeInterface;
  track_production_guid: fromDatatype.GuidDataFieldInterface;
  track_production_id: fromDatatype.VarcharDatatypeInterface;
  track_production_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_production_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_production_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_production_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_production_remarks: fromDatatype.VarcharDatatypeInterface;
  track_production_status: fromDatatype.VarcharDatatypeInterface;
  track_delivery_logic: fromDatatype.VarcharDatatypeInterface;
  track_delivery_table: fromDatatype.VarcharDatatypeInterface;
  track_delivery_guid: fromDatatype.GuidDataFieldInterface;
  track_delivery_id: fromDatatype.VarcharDatatypeInterface;
  track_delivery_time_estimated: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_actual: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_time_planned: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_pic_name: fromDatatype.VarcharDatatypeInterface;
  track_delivery_pic_contact: fromDatatype.VarcharDatatypeInterface;
  track_delivery_remarks: fromDatatype.VarcharDatatypeInterface;
  track_delivery_status: fromDatatype.VarcharDatatypeInterface;
  unit_price_net: fromDatatype.NumericDatatypeInterface;
  point_start_date: fromDatatype.TimestampTzDatatypeInterface;
  point_end_date: fromDatatype.TimestampTzDatatypeInterface;
  multi_level_disc_json: fromDatatype.JsonDatatypeInterface;
  membership_ext_start_date: fromDatatype.TimestampTzDatatypeInterface;
  track_delivery_date_requested: fromDatatype.TimestampTzDatatypeInterface;
  delivery_required: fromDatatype.VarcharDatatypeInterface;
  finance_charge_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_price: fromDatatype.NumericDatatypeInterface;
  cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  cost_wa_price: fromDatatype.NumericDatatypeInterface;
  cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_lifo_price: fromDatatype.NumericDatatypeInterface;
  cost_manual_amount: fromDatatype.NumericDatatypeInterface;
  cost_manual_price: fromDatatype.NumericDatatypeInterface;
  cost_replacement_amount: fromDatatype.NumericDatatypeInterface;
  cost_replacement_price: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_location: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_company: fromDatatype.NumericDatatypeInterface;
  posting_mto: fromDatatype.NumericDatatypeInterface;
  landed_txn_amount: fromDatatype.NumericDatatypeInterface;
  landed_txn_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_price: fromDatatype.NumericDatatypeInterface;
  delivery_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  delivery_process_status_guid: fromDatatype.GuidDataFieldInterface;
  delivery_process_status_name: fromDatatype.VarcharDatatypeInterface;
  delivery_process_resolution_guid: fromDatatype.GuidDataFieldInterface;
  delivery_process_resolution_code: fromDatatype.VarcharDatatypeInterface;
  delivery_branch_guid: fromDatatype.GuidDataFieldInterface;
  delivery_branch_code: fromDatatype.VarcharDatatypeInterface;
  delivery_location_guid: fromDatatype.GuidDataFieldInterface;
  delivery_location_code: fromDatatype.VarcharDatatypeInterface;
  tax_tariff_code: fromDatatype.GuidDataFieldInterface;
  tax_industry_code: fromDatatype.GuidDataFieldInterface;
  line_bundle_guid: fromDatatype.GuidDataFieldInterface;
  apt_weight_disc: fromDatatype.NumericDatatypeInterface;
  apt_amt_discount: fromDatatype.NumericDatatypeInterface;
  apt_amount_txn: fromDatatype.NumericDatatypeInterface;
  entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  intercompany_hdr_guid: fromDatatype.GuidDataFieldInterface;
  intercompany_line_guid: fromDatatype.GuidDataFieldInterface;
  unit_price_std_with_tax: fromDatatype.NumericDatatypeInterface;
  unit_discount: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom_with_tax: fromDatatype.NumericDatatypeInterface;
  replacement_unit_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  ref_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  delta_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price1_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price2_excl_tax: fromDatatype.NumericDatatypeInterface;
  rebate_price3_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  sales_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_min_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  purchase_max_price_excl_tax: fromDatatype.NumericDatatypeInterface;
  pricing_scheme_link_guid: fromDatatype.GuidDataFieldInterface;
  purchase_selling_list_price_incl_tax: fromDatatype.NumericDatatypeInterface;
  coupon_line_guid_json: fromDatatype.JsonDatatypeInterface;
  display_option: fromDatatype.VarcharDatatypeInterface;
  nsti_stock_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_01: fromDatatype.GuidDataFieldInterface;
  pic_entity_01_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02: fromDatatype.GuidDataFieldInterface;
  pic_entity_02_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03: fromDatatype.GuidDataFieldInterface;
  pic_entity_03_name: fromDatatype.VarcharDatatypeInterface;
  svc_issue_hdr_guid: fromDatatype.GuidDataFieldInterface;
  settlement_type: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
  session_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  discount_description: fromDatatype.VarcharDatatypeInterface;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  posting_budget: fromDatatype.VarcharDatatypeInterface;
  memberpoint_addon_json : MultiMemberPointsJson;
  packing_status: fromDatatype.VarcharDatatypeInterface;
  einvoice_uom: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_desc: fromDatatype.TextDatatypeInterface;
  einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_uom_desc: fromDatatype.TextDatatypeInterface;
  forex_source_hdr_guid: fromDatatype.GuidDataFieldInterface;
  forex_source_history_guid: fromDatatype.GuidDataFieldInterface;
  segment_code: fromDatatype.VarcharDatatypeInterface;
  project_code: fromDatatype.VarcharDatatypeInterface;
  profit_center_code: fromDatatype.VarcharDatatypeInterface;
  gl_dimension_code: fromDatatype.VarcharDatatypeInterface;
  mrp_request_status_production : fromDatatype.VarcharDatatypeInterface;
  mrp_request_status_schedule  : fromDatatype.VarcharDatatypeInterface;
  mrp_request_status_exists  : fromDatatype.VarcharDatatypeInterface;
  mrp_request_remarks  : fromDatatype.VarcharDatatypeInterface;
  einvoice_item_classification_code : fromDatatype.VarcharDatatypeInterface;
  einvoice_item_classification_desc : fromDatatype.VarcharDatatypeInterface;
  container_inv_item_guid: fromDatatype.GuidDataFieldInterface;
  revision_history_json: fromDatatype.JsonDatatypeInterface;
  posting_bundle : fromDatatype.VarcharDatatypeInterface;
  trade_tariff_code: fromDatatype.VarcharDatatypeInterface;
  trade_country_of_origin: fromDatatype.VarcharDatatypeInterface;
  parent_fi_item_code: fromDatatype.VarcharDatatypeInterface;
  parent_fi_item_name: fromDatatype.VarcharDatatypeInterface;
  sales_entity_hdr_code: fromDatatype.VarcharDatatypeInterface;
  cost_replacement_price_company: fromDatatype.NumericDatatypeInterface;
  cost_replacement_amount_company: fromDatatype.NumericDatatypeInterface;
  tax_exemption_details: fromDatatype.VarcharDatatypeInterface;
  tax_exemption_amount: fromDatatype.NumericDatatypeInterface;
  job_order_qty: fromDatatype.NumericDatatypeInterface;
  mrp_produced_qty: fromDatatype.NumericDatatypeInterface;
  packing_order_qty: fromDatatype.NumericDatatypeInterface;
}
